import * as S from "../TaskCardFirstSteps/taskCardContentsFirstSteps.styles";
import { ReactComponent as IconLeft } from "../../../../styles/assets/svg/icon-left-arrow.svg";
import { ReactComponent as IconComplete } from "../../../../styles/assets/svg/icon-check.svg";
import { ReactComponent as IconCheckTrue } from "../../../../styles/assets/svg/icon-checkbox-check-primary.svg";
import { ReactComponent as IconCheckFalse } from "../../../../styles/assets/svg/icon-checkbox-none-gray.svg";
import { ReactComponent as IconCameraWhite } from "../../../../styles/assets/svg/icon-camera-white.svg";
import {
  Transportation,
  TransportationType,
} from "../../../../interface/transportation";
import dayjs from "dayjs";
import { ReactComponent as IconReceipt } from "../../../../styles/assets/svg/icon-receipt.svg";
import { useEffect } from "react";

interface TaskCardContentFinalProps {
  unloadingCompletedData: TransportationType;
  handleNextButtonClick: () => void;
  handleBackBtnClick: () => void;
  setIsImgCheck: React.Dispatch<React.SetStateAction<boolean>>;
  setIsErrorCheck: React.Dispatch<React.SetStateAction<boolean>>;
  setIsNextLevel: React.Dispatch<React.SetStateAction<number>>;
  onImageRegisterPageMove: () => void;
  onInvoiceImageRegisterPageMove?: () => void;
  isImgCheck: boolean;
  isErrorCheck: boolean;
  step?: number; // 셔틀이나 편도일때 단계 표시 변경
  maxStep?: number;
}

const TaskCardContentsFinalSteps = ({
  unloadingCompletedData,
  handleNextButtonClick,
  handleBackBtnClick,
  onImageRegisterPageMove,
  onInvoiceImageRegisterPageMove,
  setIsImgCheck,
  setIsErrorCheck,
  setIsNextLevel,
  isImgCheck,
  isErrorCheck,
  step = 6,
  maxStep = 6,
}: TaskCardContentFinalProps) => {
  useEffect(() => {
    if (unloadingCompletedData) {
      setIsErrorCheck(unloadingCompletedData.loading_point_completed || false);
      setIsImgCheck(
        unloadingCompletedData.loading_point_img_completed || false
      );
    }
  }, [unloadingCompletedData]);

  return (
    <S.TaskBox>
      <S.TaskTotalWrapContainer>
        {unloadingCompletedData?.transport_type !== 1 && (
          <S.TaskTotalWrap onClick={onInvoiceImageRegisterPageMove}>
            <IconReceipt width={25} height={25} /> 인수증
          </S.TaskTotalWrap>
        )}
        <S.TaskTotalWrap onClick={onImageRegisterPageMove}>
          <IconCameraWhite width={25} height={25} /> 사진등록
        </S.TaskTotalWrap>
      </S.TaskTotalWrapContainer>
      <S.TaskContainer>
        <S.TaskContent>
          <S.TaskHeadBox>
            <S.Sbox>
              <S.StepBox>
                {step} / {maxStep}단계
              </S.StepBox>
              <S.StateBox>하차완료</S.StateBox>
            </S.Sbox>
            <S.DateBox>
              {dayjs(new Date()).format("YYYY-MM-DD HH:mm")}
            </S.DateBox>
          </S.TaskHeadBox>
          <S.ProgressBar progress="100%" />
          <S.CheckBoxGroup>
            <S.TaskCardCheckBox
              onClick={() => setIsImgCheck(!isImgCheck)}
              className={isImgCheck ? "checked" : ""}
              divGap="6px"
            >
              {isImgCheck ? (
                <IconCheckTrue width={25} height={25} />
              ) : (
                <IconCheckFalse width={25} height={25} />
              )}
              <p>필요한 사진 업로드를 완료했습니다.</p>
            </S.TaskCardCheckBox>
            <S.TaskCardCheckBox
              onClick={() => setIsErrorCheck(!isErrorCheck)}
              className={isErrorCheck ? "checked" : ""}
              divGap="6px"
            >
              {isErrorCheck ? (
                <IconCheckTrue width={25} height={25} />
              ) : (
                <IconCheckFalse width={25} height={25} />
              )}
              <p>컨테이너에 이상이 없습니다.</p>
            </S.TaskCardCheckBox>
          </S.CheckBoxGroup>
        </S.TaskContent>

        <S.ButtonBox>
          <S.Button width="60%" color="white" onClick={handleBackBtnClick}>
            <IconLeft width={20} height={20} />
            <S.BText>이전</S.BText>
          </S.Button>
          <S.Button
            width="100%"
            color="primary"
            isErrorCheck={isErrorCheck}
            disabled={!isErrorCheck}
            onClick={() => {
              handleNextButtonClick();
            }}
          >
            <IconComplete width={20} height={20} />
            <S.BText>완료 및 세금계산서 발행요청</S.BText>
          </S.Button>
        </S.ButtonBox>
      </S.TaskContainer>
    </S.TaskBox>
  );
};
export default TaskCardContentsFinalSteps;
